import React, { Component, type ComponentType } from 'react';
import DropDown from '../../dropDown/dropDown';
import type {
  WithDropDownOnActionDropDownProps,
  WithDropDownOnActionProps,
} from './withDropDownTypes';

export interface ComponentWithDropDownOnClickProps {
  onClick: (event: React.MouseEvent<Element, MouseEvent>) => void;
}

const withDropDownOnClick = <P extends WithDropDownOnActionProps>(
  WrappedComponent: ComponentType<P & ComponentWithDropDownOnClickProps>,
) => {
  class WithDropDownOnClick extends Component<
    WithDropDownOnActionProps & WithDropDownOnActionDropDownProps
  > {
    handleClick = (event: React.MouseEvent<Element, MouseEvent>) => {
      const { handlerKey, dropPanelKey, openedDropPanel } = this.props;

      if (dropPanelKey === openedDropPanel) {
        this.props.closeDropPanel(true);
        return;
      }

      this.props.openDropPanel(handlerKey || dropPanelKey, 0);
      this.props.onClick?.(event);
    };

    handleOuterClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;

      // if click outside of dropdown was on one of the TopBar buttons - do nothing
      // we want to handle it in the handleClick function
      if (
        target.classList.contains('top-bar-menu-bar-item') &&
        target.classList.contains('active')
      ) {
        return;
      }

      this.props.closeDropPanel(true);
    };

    render() {
      const { dropPanelKey, openedDropPanel } = this.props;
      const isOpen = dropPanelKey === openedDropPanel;

      const wrappedComponent = React.createElement(
        WrappedComponent,
        Object.assign({}, this.props as P, {
          onClick: this.handleClick,
        }),
      );

      return (
        <DropDown
          isOpen={isOpen}
          delayedFadeOut={false}
          onPanelOuterClick={this.handleOuterClick}
          panelContent={this.props.dropPanelContent}
          panelTopMargin={this.props.panelTopMargin}
          panelClassName={this.props.panelClassName}
        >
          {wrappedComponent}
        </DropDown>
      );
    }
  }

  return WithDropDownOnClick;
};

export default withDropDownOnClick;
